module.exports = __webpack_public_path__ + "img/bernardo-jaime-quito-sarmiento.f2735d57.png";